export enum DomainEnum {
  NETSKOPE = 'netskope.cygovdev.com',
  menuKey = 'netskope',
}
